export default __webpack_public_path__ + "static/media/AIG.9491dbfb.svg";